import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CurrencyService, LanguageService, ProductSearchService, RoutingService } from '@spartacus/core';
import { ProductListComponentService, ProductListRouteParams, SearchCriteria, ViewConfig } from '@spartacus/storefront';

@Injectable({
  providedIn: 'root'
})
export class CustomProductListComponentService extends ProductListComponentService {
  constructor(
    protected productSearchService: ProductSearchService,
    protected routing: RoutingService,
    protected activatedRoute: ActivatedRoute,
    protected currencyService: CurrencyService,
    protected languageService: LanguageService,
    protected router: Router,
    protected config: ViewConfig
  ) {
    super(productSearchService, routing, activatedRoute, currencyService, languageService, router, config);
  }
  /**
   * Search only if the previous search criteria does NOT match the new one.
   * This prevents repeating product search calls for queries that already have loaded data.
   */
  protected searchIfCriteriaHasChanged(criteria: SearchCriteria) {
    this.search(criteria);
  }

  /**
   * Expose the `SearchCriteria`. The search criteria are driven by the route parameters.
   *
   * This search route configuration is not yet configurable
   * (see https://github.com/SAP/spartacus/issues/7191).
   */
  protected getCriteriaFromRoute(routeParams: ProductListRouteParams, queryParams: SearchCriteria): SearchCriteria {
    return {
      query: queryParams.query || this.getQueryFromRouteParams(routeParams),
      pageSize: queryParams.pageSize || this.config.view?.defaultPageSize,
      currentPage: queryParams.page ? queryParams.page - 1 : 0,
      sortCode: queryParams.sortCode
    };
  }

  /**
   * Performs a search based on the given search criteria.
   *
   * The search is delegated to the `ProductSearchService`.
   */
  protected search(criteria: SearchCriteria): void {
    const currentPage = criteria.page || criteria.currentPage;
    const pageSize = criteria.pageSize;
    const sort = criteria.sortCode;

    this.productSearchService.search(
      criteria.query,
      // TODO: consider dropping this complex passing of cleaned object
      Object.assign({}, currentPage && { currentPage: currentPage }, pageSize && { pageSize }, sort && { sort })
    );
  }

  /**
   * Sort the search results by the given sort code and current route.
   */
  sortWithRoute(sortCode: string, activatedRoute: ActivatedRoute): void {
    const queryParams = activatedRoute.snapshot.queryParams.page ? { sortCode, page: 1 } : { sortCode };
    this.router.navigate([], {
      queryParams,
      queryParamsHandling: 'merge',
      relativeTo: activatedRoute
    });
  }
}
